import { useGetPractitionersByGroup } from 'api';
import { User } from 'types/types';
import UserPicker from './UserPicker';

type SelectUsersFromGroupProps = {
  groupId: string;
  userFilter?: (user: User) => boolean;
  setSelectedUsers: (users: any[]) => void;
  selectedUsers: any[];
  helperText?: string;
  showRole?: boolean;
};

export const SelectUsersFromGroup = ({
  groupId,
  userFilter,
  setSelectedUsers,
  selectedUsers,
  helperText,
  showRole = false,
}: SelectUsersFromGroupProps) => {
  const { data, isPending, error } = useGetPractitionersByGroup(groupId);
  const availableUsers = userFilter
    ? data?.practitioners.filter(userFilter)
    : data?.practitioners;
  return (
    <UserPicker
      selectedUsers={selectedUsers}
      users={availableUsers || []}
      loading={isPending}
      isLoadingError={!!error}
      onChange={setSelectedUsers}
      helperText={helperText}
      showRole={showRole}
    />
  );
};
